import { renderHtmlToPlainText } from './renderHtmlToPlainText'
import type { RenderMode } from './interpolateVariables'

// Rich-text editors emit a new `<p>` per Enter press, but operators expect
// signature rows (name / title / email) on consecutive lines, not blank-line-
// separated paragraphs. Collapse `<p>X</p><p>Y</p>` to `X<br>Y` first.
function normalizeSignatureHtml(html: string): string {
  return html
    .replace(/<\/p>\s*<p[^>]*>/gi, '<br>')
    .replace(/<\/?p[^>]*>/gi, '')
    .replace(/\s+$/, '')
}

export function appendSignature(
  body: string,
  signatureHtml: string,
  mode: RenderMode
): string {
  if (!signatureHtml) return body
  const normalizedSig = normalizeSignatureHtml(signatureHtml)
  if (mode === 'html') return `${body}<br>${normalizedSig}`
  const sigPlain = renderHtmlToPlainText(normalizedSig)
  const bodyTrimmed = body.replace(/\n+$/, '')
  return `${bodyTrimmed}\n\n${sigPlain}`
}
